export default "__VITE_ASSET__B9gi_W3K__"